import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  transform(text: string, search: string): string {
    if (!search) {return text;}
    const pattern = search
      .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
      .split(' ')
      .map(t => t.length > 0 ? `(${t})` : '')
      .join('\\s*');
    const regex = new RegExp(pattern, 'gi');

    return text.replace(regex, match => `<span class="ng-option-custom-style-highlight">${match}</span>`);
  }

}
